import React from "react";
import PL_TextField from "infrastructure/js/components/controls/TextField/textField";
import Dialog from "infrastructure/js/components/Dialog/dialog";
import Combobox from "infrastructure/js/components/controls/Combobox/combobox.js";
import Overlay from "infrastructure/js/components/Overlay/overlay";
import Label from "infrastructure/js/components/Label/label.js";
import InputSection from "infrastructure/js/components/Dialog/InputSection/inputSection";
import { reduxForm, clearSubmitErrors } from "redux-form";
import Normalize from "infrastructure/js/components/controls/controlsNormalizations.js";
// import * as CutLengthHelper from "../../../../utils/cutLengthHelper";
import { generateFormNames, convertOptionsToServerData, toNumberOrNull } from "infrastructure/js/utils/componentUtils.js";
import { createLabelHelper } from "infrastructure/js/utils/labelHelper";
import * as dialogHelper from "infrastructure/js/components/Dialog/dialogHelper";
import MessageDialog from "infrastructure/js/components/Dialog/MessageDialog/messageDialog.js";
import UnitHelper, { unitTypes } from "infrastructure/js/utils/uomHelper";
import MaterialHelper from "../../../../utils/materialHelper";
import { getEnumValue, enumTypes } from "../../../../utils/enumHelper";
import EntitiesMultiSelect from "../../../Common/Controls/EntitiesMultiSelect/entitiesMultiSelect.js";
import { EntityPropertyTypes } from "../../../../enums/entityPropertyTypes";
import { FetchEntitiesFilters } from "../../../../enums/fetchEntitiesFilters";
import PermissionManager from "infrastructure/js/utils/permissionManager";
import {List} from 'immutable';
import Validation from 'infrastructure/js/components/controls/controlsValidations';
import { REPORT_CUT_DIALOG_FORM } from "../../../../actions/LocationPage/CuttingView/reportCutDialogActions";

require("./reportCutDialog.scss");

class ReportCutDialog extends React.PureComponent {
  constructor(props) {
    super(props);
    this.labels = createLabelHelper("mat.locationpage.view.cutting.reportcutdialog.");
    this.dialogLabels = createLabelHelper("mat.dialog.");
  }

  createDialogFooterButtons() {
    //let isSubmitDisabled = (!this.props.valid);
    let isLoading = this.props.sData.get("loading");

    let buttonOK = {
      id: "submit",
      text: this.labels.get("footer.submit"),
      bsStyle: "primary",
      //disabled: isSubmitDisabled,
      loading: isLoading,
      action: this.props.handleSubmit(this.onSubmit),
      disabled: this.props.sData.get("loading") ||
        this.props.sData.get("hasError") ||
        (this.props.sData.get("showIgnoreValidationCheckbox") &&
          !this.props.sData.get("isIgnoreValidationWarnings"))
    };

    let buttonCancel = {
      id: "cancel",
      text: this.dialogLabels.get('cancel'),
      action: this.props.actions.hide
    };

    return { left: [buttonCancel], right: [buttonOK] };
  }

  onSubmit = (formData) => {
    let formItems = this.submitedData = formData.dialogItems;
    let stateItems = this.props.sData.get("preselectedAssets");

    let serverReadyItems = [];
    let rollsIdsData = [];

    // Built even when SAP verification is off - it costs nothing, and it keeps the branch in one
    // place (the submit action) rather than having the shape of the payload depend on the setting.
    let sapVerificationItems = [];

    formItems.forEach((formItem, index) => {
      if (!formItem) {
        return;
      }
      let item = {
        // Find Roll Id in the state data collection by matching array index from Forms collection.
        rollId: stateItems.get(index).rollId,
        nest: convertOptionsToServerData(formItem.cutNests),
        quantityPlies: toNumberOrNull(formItem.numberOfPlies),
        note: formItem.notes,
        workOrders: convertOptionsToServerData(this.getAffectedWos(formItem))
      };

      if (PermissionManager.isWeightSupported()) {
        item.weightLeft = UnitHelper.userValueToServerValue(unitTypes.WEIGHT, formItem.weight || 0);
      }
      else {
        item.lengthCut = formItem.cutLength ? (UnitHelper.userValueToServerValue(unitTypes.LENGTH, formItem.cutLength)) : 0;
      }
      serverReadyItems.push(item);
      //used to get rollBusinessId by rollId for Confirmation dialog
      rollsIdsData.push({
        rollId: stateItems.get(index).rollId,
        rollBusinessId: stateItems.get(index).rollBusinessId
      });

      // The confirmation number is the note, and the work order is the first one selected - which
      // is exactly the pair the ON_CUT_REPORTED hook goes on to send SAP for this cut
      // (ReportedCutTokenMapperImpl publishes cut.getNote() and workOrders.get(0)). Validating a
      // different pair than we report would be worse than not validating at all.
      //
      // rollBusinessId is carried for this side only: the rolls in one dialog are unrelated, so a
      // failure has to name the section the operator must go and fix.
      // rowIndex is the dialogItems position, kept because this list skips empty form rows and so
      // is not index-aligned with it. It is what lets a returned failure redden the right field.
      sapVerificationItems.push({
        rowIndex: index,
        rollBusinessId: stateItems.get(index).rollBusinessId,
        barcode: formItem.notes,
        woBusinessId: _firstWoBusinessId(formItem),
        nestBusinessId: _firstNestBusinessId(formItem)
      });
    });

    // One checkbox in the footer, two things it can promise, and they must not be confused:
    // ignoreValidationWarnings travels to the server and is permission-checked there
    // (GatewayService.checkIfUserCanIgnoreWarnings), while ignoreSapVerification never leaves the
    // client. Which one the operator actually ticked is decided by what put the checkbox on screen.
    let checkboxTicked = !!formData.footerValidationCheckbox;
    let sapVerificationFailed = this.props.sData.get("sapVerificationFailed");

    // Once taken, the SAP override holds until the form is edited, so the "continue with warnings"
    // round that may follow it does not verify against SAP again (SAAS-25304).
    let takeSapVerificationOverride = sapVerificationFailed && checkboxTicked;
    let sapVerificationIgnored = this.props.sData.get("sapVerificationIgnored");

    let newData = {
      cutsToReport: serverReadyItems,
      rollsIdsData: rollsIdsData,
      sapVerificationItems: sapVerificationItems,
      takeSapVerificationOverride: takeSapVerificationOverride,
      ignoreSapVerification: sapVerificationIgnored || takeSapVerificationOverride,
      ignoreValidationWarnings: !sapVerificationFailed &&
        this.props.sData.get("showIgnoreValidationCheckbox") && checkboxTicked
    };

    this.props.actions.submit(newData, this.getMessageDialogBuilder());
  };

  onHide = () => {
    this.props.actions.hide();
  };

  getAffectedWos = (formItem) => {
    return formItem.affectedWos.assetsValue ? formItem.affectedWos.assetsValue : null;
  };

  getMessageDialogBuilder = () => {
    return (allResponses, fnCloseDialog, fnGoKit) => {
      if (allResponses.length === 1) {
        let response = allResponses[0];

        // Success - single item dialog.
        if (this.isResponseValid(response)) {
          return this.buildDialogDescriptorForSingleItemSuccess(response, fnGoKit, fnCloseDialog);
        }
      }
      return this.buildDialogDescriptorForMultipleItems(allResponses, fnCloseDialog);
    };
  };

  isResponseValid = (response) => {
    return (response && response.applicationResponseStatus && (response.applicationResponseStatus.statusType === "OK"));
  };

  buildDialogDescriptorForMultipleItems = (allResponses, fnCloseDialog) => {

    let succeededIds = [];
    let failedIds = [];

    allResponses.forEach((response) => {
      if (this.isResponseValid(response)) {
        succeededIds.push(response.data.rollBusinessId);
      }
      else {
        failedIds.push(response.data.rollBusinessId);
      }
    });

    let totalCount = succeededIds.length + failedIds.length;
    let className = "oneBackground";
    let operationName = this.labels.get("operation.name");
    let title = "";

    if (succeededIds.length === totalCount) { //succeeded only
      title = this.labels.get("multiconfirm.header", undefined, {
        count: totalCount,
        operationName,
        status: "succeeded"
      });
      return { title, type: "success", className };
    }
    else {
      if (failedIds.length === totalCount) { //failed only
        title = this.labels.get("multiconfirm.header", undefined, {
          count: totalCount,
          operationName,
          status: "failed"
        });
        return { title, type: "error", className };
      }
      else {  //succeeded & failed
        className = "report-operation-multiple-confirmation-dialog";
        title = this.labels.get("multiconfirm.header", undefined, {
          count: totalCount,
          operationName,
          status: "reported"
        });
        let buttons = [{
          id: "close",
          text: this.dialogLabels.get("close"),
          action: fnCloseDialog,
          bsStyle: "primary"
        }];

        let children = [];

        children.push(<MessageDialog.StatusRow key="row1" type={"succeeded"} count={succeededIds.length}/>);
        children.push(<MessageDialog.MessageArea key="row2" text={succeededIds.join(", ")}/>);

        children.push(<MessageDialog.StatusRow key="row3" type={"failed"} count={failedIds.length}/>);
        children.push(<MessageDialog.MessageArea key="row4" text={failedIds.join(", ")}/>);

        return { title, children, className, buttons, showTitleIcon: false };
      }
    }

    return {};
  };


  hasKitOperation = (operations) => {
    if (operations) {
      let found = operations.find((item) => {
        return (item.operationType && item.operationType.name === getEnumValue(enumTypes.OPERATION_TYPE)("KIT"));
      });

      return !!found;
    }
    return false;
  };

  buildDialogDescriptorForSingleItemSuccess = (response, fnGoKit, fnCloseDialog) => {

    let cutId = response.data.id;
    let title = this.labels.get("confirmation.title");
    let buttons;

    //When the station has kit operation.
    if (this.hasKitOperation(this.props.sLocationOperations)) {
      buttons = [
        {
          id: "cancel",
          text: this.labels.get("confirmation.cancelreport"),
          action: () => {
            fnCloseDialog();
            return this.props.actions.onCancelCutReportClick(response.data);
          }
        },
        {
          id: "kitThis",
          text: this.labels.get("confirmation.kithis"),
          bsStyle: "primary",
          action: () => {
            return fnGoKit(cutId);
          }
        }
      ];
    }
    else { //if not, add close button.
      buttons = [
        {
          id: "close",
          text: this.labels.get("confirmation.close"),
          bsStyle: "primary",
          action: () => {
            return fnCloseDialog();
          }
        }
      ];
    }
    let children = this.buildConfirmDialogItem(response, 0, fnGoKit);

    let messageDialogDescriptor = { title, children, buttons };
    return messageDialogDescriptor;

  };


  buildConfirmDialogItem = (response, index) => {
    let rollBusinessId = response.data.rollBusinessId;
    let material = response.data.material;
    let materialLabel = material ? MaterialHelper.getMaterialFullLabel(material.materialName, material.businessId) : "";

    let rollValue = `${materialLabel}, ${rollBusinessId}`;

    let workorderValue = "";
    let affectedWos = this.getAffectedWos(this.submitedData[0]);
    if (affectedWos) {
      workorderValue = affectedWos.map((woItem, woItemIndex) => {
        let isLastItem = ((woItemIndex + 1) >= affectedWos.length);
        let woItemSeparator = (isLastItem) ? ("") : (", ");
        return (<span key={woItemIndex} href="javascript:void(0)">{woItem.label + woItemSeparator}</span>);
      });
    }

    let lengthOrWeightItem = PermissionManager.isWeightSupported() ?
      {
        label: this.labels.get("confirmation.weightUsed"),
        value: `${this.submitedData[0].weight} ${UnitHelper.getLabelForUnitType(unitTypes.WEIGHT)}`
      } :
      {
        label: this.labels.get("confirmation.lengthcut"),
        value: `${this.submitedData[0].cutLength} ${UnitHelper.getLabelForUnitType(unitTypes.LENGTH)}`
      };

    let rows = [
      { label: this.labels.get("confirmation.roll"), value: rollValue },
      { label: this.labels.get("confirmation.workorder"), value: workorderValue },
      lengthOrWeightItem,
      { label: this.labels.get("confirmation.cutid"), value: response.data.id }
    ];

    return rows.map((item, index) => {
      return <MessageDialog.DataRow id={`reportKitDataRow${index}`} key={`confirmMessageDataRow${index}`}
                                    label={item.label} value={item.value}/>;
    });
  };


  renderContentItems = (sData) => {
    let dataItems = sData.get("preselectedAssets");
    let dialogData = sData.get("dialogData");
    if (dataItems && dataItems.size === 0 || !dialogData) {
      return <Overlay.Loading/>;
    }

    let nestsOptions = dialogData.nestsOptions ? dialogData.nestsOptions : [];

    let contentItems = dataItems.map((item, index) => {
      return <RenderSingleDialogContentItem key={index} index={index} item={item}
                                            nestsOptions={nestsOptions}
                                            {...this.props}
      />;
    });

    return (
      <div className="dialog-content-wrapper">
        {contentItems}
      </div>);
  };

  // One checkbox, two promises. Which one it is making depends on what put it on screen - see
  // onSubmit, where the operator's tick is routed to the matching flag.
  getFooterValidationCheckBox = () => {
    if (!this.props.sData.get("showIgnoreValidationCheckbox")) {
      return null;
    }

    let label = this.props.sData.get("sapVerificationFailed")
      ? this.labels.get("sapverification.ignore")
      : this.dialogLabels.get("ignorewarnings");

    return { label, onChange: this.onFooterValidationChange };
  };

  onFooterValidationChange = (value) => {
    this.props.actions.toggleIgnoreValidationWarningsCheckbox(value);
  };

  render() {
    let show = this.props.sData.get("show");
    let dataItems = this.props.sData.get("preselectedAssets");
    let bodyClassName = (dataItems.size > 2) ? "modal-body-overflow" : "";

    return (
      <div>
        <Dialog
          className="report-cuts-dialog"
          bodyClassName={bodyClassName}
          sData={this.props.sData}
          show={show}
          onHide={this.onHide}
          titleText={this.labels.get("header.title")}
          footerValidationCheckbox={this.getFooterValidationCheckBox()}
          footerInformationIcon={dialogHelper.getFooterInformationIcon(this.props.sData, this.dialogLabels)}
          footerButtons={this.createDialogFooterButtons()}
          onEnterKeyPress={this.props.handleSubmit(this.onSubmit)}
        >
          {this.renderContentItems(this.props.sData)}

        </Dialog>
      </div>
    );
  }

}

class RenderSingleDialogContentItem extends React.PureComponent {

  constructor(props) {
    super(props);
    this.labels = createLabelHelper("mat.locationpage.view.cutting.reportcutdialog.");

    let { item } = this.props;
    this.state = { weight: UnitHelper.serverValueToUserValue(unitTypes.WEIGHT, item.weight), calcWeight: 0 };
    this.fetchConfig = {
      entityType: EntityPropertyTypes.WO_BUSINESS_ID,
      filter: [FetchEntitiesFilters.ACTIVE],
      action: this.props.fetchEntitiesActions.fetchEntities
    };

    this.fetchRollsConfig = {
      entityType: EntityPropertyTypes.ROLL_BUSINESS_ID,
      filter: [FetchEntitiesFilters.ACTIVE, FetchEntitiesFilters.ON_LOCATION],
      action: this.props.fetchEntitiesActions.fetchEntities,
      searchBy: {
        roll: [{
          objectName: "kitTypeId",
          values: [item?.kitTypeId]
        }]
      }
    };


    if (item && item.rollProjectId) {
      this.fetchConfig.searchBy = {
        wo: [{
          objectName: "projectId",
          values: [item.rollProjectId]
        }]
      };
    }
  }

  onWeightChanged = (event, newVal, oldVal) => {
    if (isNaN(+event.target.value)) {
      return;
    }
    let newValue = (+event.target.value);
    if (newValue > this.state.weight) {
      return;
    }
    let calcWeight = Normalize.normalizeFloat(0, parseFloat(this.state.weight))(event.target.value, oldVal);
    this.setState({ calcWeight });
  };

  onRollChanged = (newValue, oldValue) => {
    if(newValue?.value !== oldValue?.value){
      this.props.actions.onRollChanged(newValue?.data)
    }
  }

  renderLengthOrWeight = (formNames, item, index) => {
    let weight = this.state.weight;
    if (PermissionManager.isWeightSupported()) {
      return (<InputSection label={this.labels.get("weightLeft") + "*"} htmlFor={formNames.weight.id}
                            className="inline small two-columns">
        <PL_TextField name={formNames.weight.name} id={formNames.weight.id}
                      normalize={Normalize.normalizeFloat(0, weight)}
                      autoFocus={index === 0} onChange={this.onWeightChanged}
                      placeholder={`${weight} ${UnitHelper.getLabelForUnitType(unitTypes.WEIGHT)}`}
        />
        <div
          className="explanation">{this.labels.get("consumeWeight")}: <br/>{`${UnitHelper.round(this.state.weight - this.state.calcWeight)} ${UnitHelper.getLabelForUnitType(unitTypes.WEIGHT)}`}
        </div>
      </InputSection>);
    }

    let rollLength = item.rollLengthLeft ? UnitHelper.serverValueToUserValue(unitTypes.LENGTH, item.rollLengthLeft) : 0;
    let rollLengthDisplay = `${rollLength} ${UnitHelper.getLabelForUnitType(unitTypes.LENGTH)}`;

    return (<InputSection label={this.labels.get("lengthcut") + "*"} htmlFor={formNames.cutLength.id}
                          className="inline small two-columns">
      <PL_TextField name={formNames.cutLength.name} id={formNames.cutLength.id}
                    // validate={CutLengthHelper.validateFloat}
                    validate={Validation.required}
                    // normalize={CutLengthHelper.normalizeFloat(0, parseFloat(rollLength))}
                    normalize={Normalize.normalizeFloat(0, parseFloat(rollLength))}
                    autoFocus={index === 0}
      />
      <div className="explanation">{this.labels.get("rolllength")}: <br/>{rollLengthDisplay}</div>
    </InputSection>);
  };
  getPreselectedWos = () => {
    return List(this.props.item.affectedWos)
  }

  render() {
    let { index, item, nestsOptions, allowRollSelection, ...others } = this.props;

    // Create object with pre-fabricated "names" and "id"s for all possible controls of the current item.
    let formNames = generateFormNames(item, "dialogItems", "ReportCutDialog-", index);
    let rollTitle = this.labels.get("title.roll", undefined, { rollId: item.rollBusinessId });
    let materialLabel = MaterialHelper.getMaterialFullLabel(item.rollMaterialName, item.rollMaterial);

    return (
      <div className="dialog-item-section">

        {!this.props.sData.get('allowRollSelection') &&
          <div className="title">
            <Label text={materialLabel}/>
            <Label text={rollTitle} tooltip={item.rollBusinessId}/>
          </div>
        }

        {this.props.sData.get('allowRollSelection') &&
          <InputSection label={this.labels.get("selectRoll") + '*'} htmlFor={formNames.rollId.id}>
            <EntitiesMultiSelect
              name={formNames.rollId.name}
              id={formNames.rollId.id}
              isMulti={false}
              entitiesTypes={[getEnumValue(enumTypes.OBJECT_TYPE)("ROLL")]}
              fetchConfig={this.fetchRollsConfig}
              showEntitiesTypes={false}
              onValueChangeCallback={this.onRollChanged}
              validate={Validation.required}
              {...others}
            />
          </InputSection>
        }

        {this.renderLengthOrWeight(formNames, item, index)}

        <InputSection label={this.labels.get("affectedwos")} htmlFor={formNames.affectedWos.id} className="inline big">
          <EntitiesMultiSelect
            name={formNames.affectedWos.name}
            id={formNames.affectedWos.id}
            entitiesTypes={[getEnumValue(enumTypes.OBJECT_TYPE)("WO")]}
            fetchConfig={this.fetchConfig}
            showEntitiesTypes={false}
            allowNewOption={PermissionManager.hasCreateAssetsPermissions()}
            preSelectedEntities={this.getPreselectedWos()}
            disableOnPreselect={true}
            {...others}
          />

        </InputSection>

        <InputSection label={this.labels.get("numberofplies")} htmlFor={formNames.numberOfPlies.id}
                      className="inline small two-columns">
          <PL_TextField name={formNames.numberOfPlies.name} id={formNames.numberOfPlies.id} placeholder=""
                        normalize={Normalize.number(true, 1, 9999)}/>
        </InputSection>

        <InputSection label={this.labels.get("cutnests")} htmlFor={formNames.cutNests.id} className="inline big">
          <Combobox id={formNames.cutNests.id} name={formNames.cutNests.name} options={nestsOptions}
                    allowNewOption={true}/>
        </InputSection>

        {this.renderNotes(formNames)}
      </div>
    );
  }

  // With SAP verification on this stops being a free-text note: it carries the confirmation number
  // ("Rueckmeldenummer") the operator scans off the job card, so it gets a real label and becomes
  // required - validating an empty value is pointless, and a local check beats a round trip.
  //
  // Deliberately still the `notes` form field. It is persisted as the cut's note either way, which
  // is what the ON_CUT_REPORTED hook already sends SAP as {{PL_GKN_BWARTWA}}; nothing downstream
  // of this dialog has to know the field changed meaning.
  //
  // Not auto-focused. Unlike the Import Cut Plan wizard's scan-scan-scan rhythm, this dialog has a
  // work order, a length and a ply count to fill in first, and focus stays on the length field
  // where it has always been.
  renderNotes = (formNames) => {

    if (!PermissionManager.getOrgPreferences().sapVerificationEnabled) {
      return (
        <InputSection label="" htmlFor={formNames.notes.id}>
          <PL_TextField iconClass="pl pl-note-icon-blue" name={formNames.notes.name} id={formNames.notes.id}
                        placeholder={this.labels.get("addnote.inputclue")}/>
        </InputSection>
      );
    }

    return (
      <InputSection label={this.labels.get("sapconfirmationnumber") + "*"} htmlFor={formNames.notes.id}
                    className="inline big">
        <PL_TextField name={formNames.notes.name} id={formNames.notes.id}
                      validate={NOTES_VALIDATORS}
                      placeholder={this.labels.get("sapconfirmationnumber.inputclue")}/>
      </InputSection>
    );
  };
}

////////////////////////////////////////////////////////////////

/**
 * The work order a cut is reported against. GKN do not cut one roll against several, and the
 * ON_CUT_REPORTED hook sends only the first regardless, so the first is the one that matters.
 */
function _firstWoBusinessId(formItem) {
  let wos = formItem?.affectedWos?.assetsValue;
  return (wos && wos.length > 0) ? wos[0].label : null;
}

/**
 * Optional on the wire - whether it is sent at all, or correlated on, is the External Data Source
 * definition's decision. The combobox hands back a single option or an array depending on how it
 * was filled, so both are accepted.
 */
function _firstNestBusinessId(formItem) {
  let nests = formItem?.cutNests;

  if (!nests) {
    return null;
  }

  return Array.isArray(nests) ? (nests[0]?.label ?? null) : (nests.label ?? null);
}

/**
 * Rejects a confirmation number used against two *different* work orders in this dialog.
 *
 * Same rule as the Import Cut Plan wizard's Barcode column - see barcodeValidation.js, which this
 * deliberately mirrors. Repeating one number across several rows of the SAME work order is
 * legitimate and stays allowed: a confirmation covers the work order, not the line, and the server
 * collects the dialog's confirmations into a Set before posting them, so a repeat under one work
 * order is sent to SAP exactly once. Straddling two work orders is the case that cannot be right.
 *
 * The work order half of the key is the MAT business id the operator sees ("20605642_Gewebe"), not
 * the GKN number SAP is told ("20605642"). The two disagree in exactly one case - one GKN job card
 * split into several MAT work orders by kit type, sharing a confirmation - which reads as a clash
 * here though SAP would accept it. Deliberate, and deliberately the same call the wizard makes: the
 * operator can only reason about what the screen shows them. If GKN ever wants those accepted, this
 * function and the wizard's duplicateKeyWorkOrder are the two places to change together.
 *
 * <b>Field-level rather than the form-level `validate` config, and that is not a style choice.</b>
 * reduxForm forwards its `validate` config to the wrapped component as an ordinary prop - it is
 * absent from redux-form's own exclusion list in createReduxForm - and this dialog spreads
 * `{...others}` onto its EntitiesMultiSelects. A form-level validator therefore reaches a Field and
 * is re-invoked with a single field's value as its first argument, which blew the dialog up.
 *
 * Note this is only about clashes *within one dialog*. A number already consumed by an earlier cut
 * is SAP's to reject, and the verification call is what asks.
 */
const validateNoDuplicateConfirmation = (value, allValues) => {

  if (!PermissionManager.getOrgPreferences().sapVerificationEnabled) {
    return undefined;
  }

  let barcode = (value || "").trim();

  // An empty field is Validation.required's business, not this one's.
  if (!barcode) {
    return undefined;
  }

  let items = allValues?.dialogItems;

  if (!items) {
    return undefined;
  }

  // Every distinct work order this number appears under, across the whole dialog. A missing work
  // order is kept as its own key ("") rather than skipped: with no work order there is nothing for
  // SAP to correlate the confirmation against, so pairing such a row with a real one is precisely
  // the clash this rule exists to catch.
  //
  // Computed the same way for every row carrying the number, so all of them light up together - the
  // operator cannot tell which end of the pair is the typo from one end alone.
  let workOrders = new Set();

  items.forEach(function (formItem) {
    if (formItem && (formItem.notes || "").trim() === barcode) {
      workOrders.add(_firstWoBusinessId(formItem) || "");
    }
  });

  if (workOrders.size <= 1) {
    return undefined;
  }

  return createLabelHelper("mat.locationpage.view.cutting.reportcutdialog.")
           .get("sapconfirmationnumber.duplicate");
};

/**
 * One stable reference. An inline array literal in render is a new value on every pass, and
 * redux-form re-registers a field whose validators change identity - which does not settle.
 */
const NOTES_VALIDATORS = [Validation.required, validateNoDuplicateConfirmation];

export default ReportCutDialog = reduxForm({
    form: REPORT_CUT_DIALOG_FORM,

    onChange: (values, dispatch, props, previousValues) => {

      dialogHelper.onFormChangeHandler(values, props, previousValues);

      /**
       * Any edit drops the SAP verdicts painted on the fields.
       *
       * They are held in redux-form's submit-error channel, and `isValid` counts those - so while
       * any remain, `handleSubmit` refuses to run and REPORT CUTS becomes a silent no-op. That would
       * break the override (tick the box, press again, nothing happens) and the ordinary case of
       * fixing one of two bad numbers, where the untouched row's error keeps the whole form invalid.
       * Ticking the override checkbox is itself a change, so it clears them on the way past.
       *
       * Clearing them here rather than setting `persistentSubmitErrors` is the important part. That
       * flag makes handleSubmit run *whatever* the form's state - the gate is `valid ||
       * persistentSubmitErrors` - which silently disables the sync validators too, so a missing or
       * duplicated confirmation number would sail straight through to SAP. Client-side validation is
       * the first gate and has to stop the call being made at all.
       *
       * <b>Every access below is optional-chained, and that is not defensive habit - it is
       * required.</b> `onChange` is a reduxForm *config* key, and config keys are forwarded to the
       * wrapped component as ordinary props unless they are on redux-form's exclusion list in
       * createReduxForm. `onChange` is not on it. This dialog then spreads `{...others}` into
       * EntitiesMultiSelect, which spreads again into the async select, so this very function also
       * lands on react-select as its `onChange` - and react-select calls it with its own arguments,
       * `(selectedOption, actionMeta)`. In that call `props` is undefined and `dispatch` is an
       * object, so anything that assumes otherwise throws inside the select's change handler and
       * the option click is silently lost: the Work Order menu opens and scrolls but nothing can be
       * selected.
       *
       * That is exactly why dialogHelper.onFormChangeHandler above opens with `props && props.sData`
       * - it has been absorbing this same leak all along. Sibling of the `validate` leak; see the
       * traps section of the plan doc.
       */
      if (props?.sData?.get("sapVerificationFailed")) {
        dispatch(clearSubmitErrors(REPORT_CUT_DIALOG_FORM));
      }
    }
  }
)(ReportCutDialog);
